import { Button, Flex, Spinner, Text } from '@chakra-ui/react';
import { Card, Table } from '@ui';
import { useState } from 'react';
import { buildRfiBulkExportRows, RfiBulkExportRow } from './exportUtils';

export type RfiLogExportSelection = {
  id: number;
  rfi_number: string;
  subject: string;
  status: string;
};

export default function ExportRfiLogModal({
  selectedRfis,
  onExport,
}: {
  selectedRfis: RfiLogExportSelection[];
  onExport: (rows: RfiBulkExportRow[]) => Promise<void>;
}) {
  const [isExporting, setIsExporting] = useState(false);
  const exceedsExportLimit = selectedRfis.length > 500;

  return (
    <Flex direction="column" gap={5} width="full">
      <Text>
        The export will use each RFI’s latest saved data automatically.
      </Text>
      {exceedsExportLimit && (
        <Text color="red.600">
          A single PDF can include up to 500 RFIs. Reduce the selection and try
          again.
        </Text>
      )}

      <Flex direction="column" gap={2}>
        <Text fontWeight="semibold">Selected RFIs</Text>
        <Card>
          <Table
            columns={[
              {
                rfi_number: {
                  label: 'RFI #',
                  width: '120px',
                },
              },
              {
                subject: {
                  label: 'Subject',
                  width: '280px',
                },
              },
              {
                status: {
                  label: 'Status',
                  width: '140px',
                },
              },
              {
                id: {
                  label: 'ID',
                  width: '90px',
                },
              },
            ]}
            items={selectedRfis}
          />
        </Card>
      </Flex>

      <Button
        colorPalette="blue"
        alignSelf="flex-start"
        disabled={isExporting || !selectedRfis.length || exceedsExportLimit}
        onClick={async () => {
          setIsExporting(true);
          try {
            await onExport(buildRfiBulkExportRows(selectedRfis));
          } finally {
            setIsExporting(false);
          }
        }}
      >
        {isExporting && <Spinner size="xs" mr={2} />}
        {isExporting ? 'Exporting…' : 'Export'}
      </Button>
    </Flex>
  );
}
